/**
 * Re-sorts collection/search product grids when sort_by is title-ascending | title-descending.
 * Shopify sorts by full title, so a shared "Watkins …" prefix makes A–Z useless; we strip a leading
 * "Watkins" (case-insensitive) for comparison only.
 * Promo / non-product nodes stay in their original grid slots; only product cards are rearranged.
 */
(function () {
  const TITLE_SORTS = new Set(['title-ascending', 'title-descending']);

  function getSortByFromPage() {
    const fromUrl = new URLSearchParams(window.location.search).get('sort_by');
    if (fromUrl) return fromUrl;
    const inForm = document.querySelector('#storefront-filters-form input[name="sort_by"]');
    return inForm?.value || '';
  }

  function normalizeSortKey(title) {
    if (!title) return '';
    return title.replace(/^\s*watkins\b\s*/i, '').trim();
  }

  function getTitleFromNode(node) {
    const card = node.matches?.('[data-product-card]')
      ? node
      : node.querySelector?.('[data-product-card]');
    if (!card) return '';
    const el = card.querySelector(
      '.product-title, a.product-title, h1.product-title, h2.product-title, h3.product-title'
    );
    return el?.textContent?.trim() || '';
  }

  function isProductGridChild(el) {
    if (!(el instanceof Element)) return false;
    if (el.classList.contains('card-product-promo') || el.querySelector?.('.card-product-promo')) {
      return false;
    }
    return el.matches('[data-product-card]') || Boolean(el.querySelector?.('[data-product-card]'));
  }

  function compareNodes(a, b, descending) {
    const ka = normalizeSortKey(getTitleFromNode(a));
    const kb = normalizeSortKey(getTitleFromNode(b));
    const cmp = ka.localeCompare(kb, undefined, { sensitivity: 'base' });
    return descending ? -cmp : cmp;
  }

  /**
   * Sort product slots in place so promo / other nodes keep their original indexes.
   * @param {Element} grid
   * @param {boolean} descending
   * @param {(el: Element) => boolean} isProduct
   */
  function reorderKeepingNonProductSlots(grid, descending, isProduct) {
    const children = Array.from(grid.children);
    const products = children.filter(isProduct);
    if (products.length < 2) return;

    products.sort((a, b) => compareNodes(a, b, descending));

    let productCursor = 0;
    const frag = document.createDocumentFragment();
    children.forEach((el) => {
      if (isProduct(el)) {
        frag.appendChild(products[productCursor++]);
      } else {
        frag.appendChild(el);
      }
    });
    grid.appendChild(frag);
  }

  function reorderCollectionGrid(grid, descending) {
    reorderKeepingNonProductSlots(grid, descending, (el) => {
      if (el.classList.contains('card-product-promo') || el.querySelector?.('.card-product-promo')) {
        return false;
      }
      return el.matches('[data-product-card]');
    });
  }

  function reorderSearchRow(row, descending) {
    reorderKeepingNonProductSlots(row, descending, isProductGridChild);
  }

  function applyWatkinsAwareTitleSort() {
    const sortBy = getSortByFromPage();
    if (!TITLE_SORTS.has(sortBy)) return;

    const descending = sortBy === 'title-descending';
    const container =
      document.querySelector('[data-collection-container]') ||
      document.querySelector('[data-search-container]');
    if (!container) return;

    const listing = container.querySelector('[data-products-grid], [data-results-grid]');
    if (!listing) return;

    const grid = listing.querySelector('.product-list__grid') || listing.querySelector('[id^="result-grid-"]');
    if (!grid) return;

    if (grid.classList.contains('product-list__grid')) {
      reorderCollectionGrid(grid, descending);
    } else {
      reorderSearchRow(grid, descending);
    }
  }

  function init() {
    applyWatkinsAwareTitleSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(init);
  });

  if (typeof eventBus !== 'undefined' && typeof THEME_EVENTS !== 'undefined') {
    eventBus.subscribe(THEME_EVENTS.FilterUpdate, () => {
      requestAnimationFrame(applyWatkinsAwareTitleSort);
    });
  }
})();
